import React from 'react';
import { Typography } from '@navi/web-ui/lib/primitives';
import { ActivityAndBreakTypes, ActivityTypeLabels } from './constants';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import SuspenseLoader from '@cp/src/components/SkeletonLoader/SuspenseLoader';
import LineLoader from '@cp/src/components/SkeletonLoader/LineLoader';
import { convertTimeToMinutes } from './utils';
import renderColorIndication from './RenderColorIndication';
import renderActivityBar from './RenderActivityBar';

const TodaysBreak = ({ isLoading }: { isLoading: boolean }) => {
  const { activityCardData } = useSelector((state: RootState) => state.leaderboard);

  const breakTimeData = activityCardData?.activityMetrics?.breakTimeByReason || {};
  const totalBreakTime = activityCardData?.activityMetrics?.totalBreakMinutes || 0;

  const todaysBreaks = [
    {
      type: ActivityAndBreakTypes.MORNING_BREAK,
      durationInMinutes: breakTimeData.MORNING_BREAK || 0
    },
    { type: ActivityAndBreakTypes.LUNCH_BREAK, durationInMinutes: breakTimeData.LUNCH_BREAK || 0 },
    {
      type: ActivityAndBreakTypes.EVENING_BREAK,
      durationInMinutes: breakTimeData.EVENING_BREAK || 0
    },
    { type: ActivityAndBreakTypes.OTHERS, durationInMinutes: breakTimeData.OTHERS || 0 }
  ];

  return (
    <div className="h-1/2">
      <div className="flex justify-between items-start mb-1">
        <Typography variant="p5" color="var(--grayscale-2)">
          Breaks
        </Typography>
        <div className="flex space-x-4">
          {renderColorIndication(
            ActivityTypeLabels[ActivityAndBreakTypes.MORNING_BREAK].labelInDef,
            'var(--blue-border)'
          )}
          {renderColorIndication(
            ActivityTypeLabels[ActivityAndBreakTypes.LUNCH_BREAK].labelInDef,
            'var(--blue-light-1)'
          )}
          {renderColorIndication(
            ActivityTypeLabels[ActivityAndBreakTypes.EVENING_BREAK].labelInDef,
            'var(--navi-color-orange-border)'
          )}
          {renderColorIndication(
            ActivityTypeLabels[ActivityAndBreakTypes.OTHERS].labelInDef,
            'var(--navi-color-violet-border)'
          )}
        </div>
      </div>
      <div className="bg-[var(--bg-blue-1)] p-4 rounded-lg">
        <SuspenseLoader
          loading={isLoading}
          fallBack={
            <>
              <LineLoader />
              <LineLoader />
            </>
          }
        >
          <div className="flex flex-row justify-between items-center gap-4">
            <div className="flex flex-col justify-between items-start gap-1 w-[85px]">
              <Typography variant="p5" color="var(--grayscale-2)">
                Break taken
              </Typography>
              <Typography variant="h5" color="var(--grayscale-1)">
                {convertTimeToMinutes(totalBreakTime)}
              </Typography>
            </div>
            <div className="w-full">
              {renderActivityBar({
                activities: todaysBreaks,
                totalExpectedMinutes: 90
              })}
            </div>
          </div>
        </SuspenseLoader>
      </div>
    </div>
  );
};

export default TodaysBreak;
